<main class="info-container" role="main" aria-labelledby="page-title">
    <div class="info-area" role="region" aria-label="Notification">
        <img
            src="/assets/images/placeholder-img.svg"
            width="394px"
            height="300px"
            class="placeholder-image"
            alt=""
            role="presentation"
        />
        <h1 class="title" id="page-title">We need some more info for the most accurate quote.</h1>
        <h2>Thank you!</h2>
        <p class="text-info">
            We have received your request for cleaning and will contact you shortly to schedule. We
            can't wait to make your home sparkle!
        </p>
    </div>
    <a [href]="localSiteUrl" class="link-back">Back to main site</a>
</main>
